import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "panel" }
const _hoisted_2 = { class: "emp-h4" }
const _hoisted_3 = { class: "emp-tag-row" }
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.label), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, i) => {
        return (_openBlock(), _createElementBlock("span", {
          key: i,
          class: "emp-tag",
          title: "Click to remove",
          onClick: ($event: any) => (_ctx.removeItem(i))
        }, _toDisplayString(item), 9, _hoisted_4))
      }), 128)),
      (_ctx.adding)
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 0,
            ref: "tagInput",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newItem) = $event)),
            type: "text",
            class: "emp-tag-input",
            onKeyup: [
              _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.commitAdd()), ["enter"])),
              _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.cancelAdd()), ["esc"]))
            ],
            onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.commitAdd()))
          }, null, 544)), [
            [_vModelText, _ctx.newItem]
          ])
        : (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "emp-tag emp-tag-add",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.startAdd()))
          }, "Add"))
    ])
  ]))
}